import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import Layout from "../components/Layout";
import GoogleSignInButton from "../components/GoogleSignInButton";
import { LOGO_FULL, API } from "../constants";

export default function RegisterPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await axios.post(`${API}/auth/register`, { name, email, password }, { withCredentials: true });
      login(res.data.user, res.data.token);
      toast.success("Account created successfully!");
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4 py-16">
        <div className="card-glass p-8 w-full max-w-md" data-testid="register-form">
          <div className="text-center mb-8">
            <img src={LOGO_FULL} alt="Top Screen" className="mx-auto mb-4" style={{height: '264px'}} />
            <h1 className="font-heading text-2xl font-bold text-white">Create Account</h1>
            <p className="text-[#E8E4DC]">Start your free trial today</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-[#E8E4DC] mb-1">Full Name</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-dark w-full" placeholder="John Doe" required data-testid="register-name" />
            </div>
            <div>
              <label className="block text-sm text-[#E8E4DC] mb-1">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark w-full" placeholder="you@example.com" required data-testid="register-email" />
            </div>
            <div>
              <label className="block text-sm text-[#E8E4DC] mb-1">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark w-full" placeholder="••••••••" required minLength={6} data-testid="register-password" />
            </div>
            <button type="submit" disabled={isLoading} className="btn-primary w-full" data-testid="register-submit">
              {isLoading ? "Creating account..." : "Create Account"}
            </button>
          </form>
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-white/10"></div></div>
            <div className="relative flex justify-center text-sm"><span className="px-2 text-[#E8E4DC]">or continue with</span></div>
          </div>
          <GoogleSignInButton />
          <p className="text-center text-[#E8E4DC] mt-6">
            Already have an account?{" "}
            <Link to="/login" className="text-[#A3E635] hover:underline" data-testid="register-login-link">Sign in</Link>
          </p>
        </div>
      </div>
    </Layout>
  );
}
